// Tile Generator 
document.addEventListener("DOMContentLoaded", function() {  

// MOONGLOW TILES
   generateTile({
    enabled: true, // true or false
    collection: 'moonglow-jewelry, moonglow-charmed-simplicity, moonglow-sky-light-gold', // 'collection-handle' or 'all', comma-seperated for multiple
    position: 'first', // 'first', 'last', 'random' or numeric tile position on grid -1
    productCardTitleText: 'COMPLIMENTARY GIFT BOX WITH PURCHASE', // title displayed on tile
    anchorURL: '', // url when tile is clicked
    imageURL: 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/moonglow-square.jpg?v=1727446496' // image displayed on tile 
  }, false);
  
// BEEKMAN TILES
   generateTile({
    enabled: true, // true or false
    collection: 'beekman-1802-almond-honey-cookie, beekman-1802-fig-leaf, beekman-1802-honey-orange-blossom, beekman-1802-honeyed-grapefruit, beekman-1802-lavender, beekman-1802-pure-goat-milk, beekman-1802-sunshine-lemon, beekman-1802-vanilla-absolute', // 'collection-handle' or 'all', comma-seperated for multiple
    position: 'random', // 'first', 'last', 'random' or numeric tile position on grid -1
    productCardTitleText: '', // title displayed on tile
    anchorURL: '', // url when tile is clicked
    imageURL: 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/goat-milk-difference_99e66fd6-da0b-4505-9bcd-af61499115a8.jpg?v=1698806073' // image displayed on tile 
  }, false);
  
  generateTile({
    enabled: true, // true or false
    startDate: '2023-10-01', // start showing tile on this date, format yyyy-mm-dd
    endDate: '2023-10-31',  // stop showing tile on this date, format yyyy-mm-dd
    collection: 'bath-body, beekman, medium, fertilizer, cat, chimes, fashion, indoor-pots, noble-micks', // 'collection-handle' or 'all', comma-seperated for multiple
    position: 'random', // 'first', 'last', 'random' or numeric tile position on grid -1
    productCardTitleText: 'YOU FOUND THE KITTY!', // title displayed on tile
    anchorURL: 'https://floralacres.ca/pages/halloween-scavenger-hunt-2023', // url when tile is clicked
    imageURL: 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/2023-halloween-cat.jpg?v=1696276295' // image displayed on tile 
  }, false);








  
});